import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Core } from "@faire/design-tokens";
import { getExtension } from "@faire/help-center-utils/lib/files";
import { formatBytes } from "@faire/web/common/formatBytes";
import { backwardsCompatibleValues } from "@faire/web/common/localization";
export var useFileUploaderDropzoneState = function useFileUploaderDropzoneState(_ref) {
  var onUploadSuccess = _ref.onUploadSuccess,
    onUploadError = _ref.onUploadError,
    accepts = _ref.accepts,
    maxFileSize = _ref.maxFileSize,
    currentFile = _ref.currentFile,
    loading = _ref.loading,
    error = _ref.error,
    strictLocalize = _ref.strictLocalize;
  var handleAcceptedFile = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(acceptedFile) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return onUploadSuccess(acceptedFile);
          case 3:
            _context.next = 8;
            break;
          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
            onUploadError(UPLOADING_ERROR_MESSAGE(acceptedFile, strictLocalize));
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 5]]);
    }));
    return function handleAcceptedFile(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleRejectedFile = function handleRejectedFile(rejection) {
    var baseMessage = BASE_MESSAGE(rejection.file, strictLocalize);
    if (rejection.file.size > maxFileSize) {
      var fileSizeMessage = FILE_SIZE_ERROR_MESSAGE(maxFileSize, strictLocalize);
      onUploadError("".concat(baseMessage, " ").concat(fileSizeMessage));
    } else if (!accepts.includes(rejection.file.type)) {
      var fileTypeMessage = FILE_TYPE_ERROR_MESSAGE(rejection.file, strictLocalize);
      onUploadError("".concat(baseMessage, " ").concat(fileTypeMessage));
    } else {
      var defaultMessage = DEFAULT_ERROR_MESSAGE(strictLocalize);
      onUploadError("".concat(baseMessage, " ").concat(defaultMessage));
    }
  };
  var handleDropResult = function handleDropResult(acceptedFiles, rejectedFiles) {
    acceptedFiles.forEach(function (acceptedFile) {
      return handleAcceptedFile(acceptedFile);
    });
    rejectedFiles.forEach(function (rejectedFile) {
      return handleRejectedFile(rejectedFile);
    });
  };
  var showChosenFile = !!currentFile && !loading;
  var showUploadError = !currentFile && !!error;
  var iconColor = showUploadError ? Core.text.critical : Core.text.subdued;
  return {
    handleDropResult: handleDropResult,
    showChosenFile: showChosenFile,
    showUploadError: showUploadError,
    iconColor: iconColor
  };
};
var BASE_MESSAGE = function BASE_MESSAGE(file, strictLocalize) {
  return strictLocalize({
    id: "+jsFYt",
    defaultMessage: [{
      "type": 0,
      "value": "Fout bij het uploaden van "
    }, {
      "type": 1,
      "value": "fileName"
    }, {
      "type": 0,
      "value": "."
    }]
  }, backwardsCompatibleValues({
    fileName: file.name
  }));
};
var UPLOADING_ERROR_MESSAGE = function UPLOADING_ERROR_MESSAGE(file, strictLocalize) {
  return strictLocalize({
    id: "0ZOu5r",
    defaultMessage: [{
      "type": 0,
      "value": "Fout bij uploaden van "
    }, {
      "type": 1,
      "value": "fileName"
    }, {
      "type": 0,
      "value": ". Probeer het opnieuw."
    }]
  }, backwardsCompatibleValues({
    fileName: file.name
  }));
};
var FILE_SIZE_ERROR_MESSAGE = function FILE_SIZE_ERROR_MESSAGE(maxSize, strictLocalize) {
  return strictLocalize({
    id: "AX7UNL",
    defaultMessage: [{
      "type": 0,
      "value": "Upload een bestand dat kleiner is dan "
    }, {
      "type": 1,
      "value": "fileSize"
    }, {
      "type": 0,
      "value": "."
    }]
  }, backwardsCompatibleValues({
    fileSize: formatBytes(maxSize, strictLocalize)
  }));
};
var FILE_TYPE_ERROR_MESSAGE = function FILE_TYPE_ERROR_MESSAGE(file, strictLocalize) {
  return strictLocalize({
    id: "TGXaM/",
    defaultMessage: [{
      "type": 0,
      "value": "‘"
    }, {
      "type": 1,
      "value": "fileType"
    }, {
      "type": 0,
      "value": "’ is geen ondersteund bestandstype."
    }]
  }, backwardsCompatibleValues({
    fileType: getExtension(file)
  }));
};
var DEFAULT_ERROR_MESSAGE = function DEFAULT_ERROR_MESSAGE(strictLocalize) {
  return strictLocalize({
    id: "DTts//",
    defaultMessage: [{
      "type": 0,
      "value": "Probeer het opnieuw."
    }]
  });
};